export default __webpack_public_path__ + "static/media/move-pressed.55d58d08.svg";